module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-147-retro.7ce15cf5.jpg";